<table datatable class="table align-middle effects-table" *ngIf="!showDeterminantBuilder">
	<thead>
		<tr>
			<th></th>
			<th class="text-left">{{'Determinant' | translate}}</th>
			<th class="text-left" colspan="2">{{'Custom Error Message' | translate}}</th>
		</tr>
	</thead>
	<tbody
		cdkDropList
		[cdkDropListData]="dynamicValidation?.validationRows"
		(cdkDropListDropped)="dropped($event)">
		<tr cdkDrag *ngFor="let item of dynamicValidation?.validationRows; let i = index">
			<td></td>
			<td>
				<div (click)="openDeterminantModal(item)">
					<determinant-query-readonly *ngIf="!isDeterminantEmpty(item.jsonDeterminants)"
                                                [jsonDeterminants]="item.jsonDeterminants"
                                                [determinantMapById]="determinantMapById"
                    ></determinant-query-readonly>
					<div class="workarea__draghere" *ngIf="isDeterminantEmpty(item.jsonDeterminants)">
						<div class="editBtn text-dark">{{ "Select a determinant" | translate }}</div>
					</div>
				</div>
			</td>
			<td>
				<div>
					<input class="form-control"
						   type="text"
						   name="validationMessage"
						   [(ngModel)]="item.validationMessage"
						   [rangeLength]="[2, 256]"
						   (blur)="save()"
						   (focus)="disableSave()"
						   placeholder="{{ 'Custom Error Message' | translate }}"
						   required />
				</div>
			</td>
			<td class="cell-delete">
				<i class="btn-xs btn-bordered btn-danger btn-icon fas fa-times" (click)="deleteRow(i)"></i>
			</td>
		</tr>
		<tr>
			<td></td>
			<td>
				<div (click)="openDeterminantModal(newRow)">
					<determinant-query-readonly *ngIf="!isDeterminantEmpty(newRow.jsonDeterminants)"
                                                [jsonDeterminants]="newRow.jsonDeterminants"
                                                [determinantMapById]="determinantMapById"></determinant-query-readonly>
					<div class="workarea__draghere" *ngIf="isDeterminantEmpty(newRow.jsonDeterminants)">
						<div class="editBtn text-dark">{{ "Select a determinant" | translate }}</div>
					</div>
				</div>
			</td>
			<td>
				<div>
					<input class="form-control"
						   type="text"
						   name="validationMessage"
						   [(ngModel)]="newRow.validationMessage"
						   [rangeLength]="[2, 256]"
						   placeholder="{{ 'Custom Error Message' | translate }}"
						   required />
				</div>
			</td>
			<td class="text-center">
				<button class="btn btn-outline-primary" type="button"
					(click)="addNewRow()" [disabled]="isAddButtonDisabled()">{{ 'Add' | translate }}</button>
				<warning-tooltip [text]="'Dont forget!'"></warning-tooltip>
			</td>
		</tr>
	</tbody>
</table>

<!-- determinant window 
<div class="row layer sub-layer mt-0" id="detFromFormio"
    [ngClass]="{'sub-layer-active': showDeterminantBuilder, 'hidden': !showDeterminantBuilder}" *ngIf="showDeterminantBuilder">
    <layer-header [customClass]="'mt-0'" (closeLayer)="closeDeterminantLayer()" (setListView)="setListView($event)" [listToggle]="listToggle"
        [listIcons]=false title="{{'Apply determinant' | translate}}" *ngIf="store.state.common.determinantSection.topLayer !== 'edit'">
        <ng-content></ng-content>
    </layer-header>
    <determinant-new *ngIf="store.state.common.determinantSection.topLayer === 'edit'"
        class="row layer sub-layer onTop-sub-layer" [serviceId]="serviceId" id="newDetFromFormio" [isOnSubLayer]="true"
        [determinant]="store.state.common.determinantSection.determinant" (formSubmit)="closeEdit()"
        (editCancel)="closeEdit()"></determinant-new>
    <div class="row {{store.state.common.determinantSection.topLayer === 'edit' ? 'hidden' : ''}}">
        <div class="col-12">
            <div class="row">
                <determinant-builder-new [serviceId]="serviceId" [jsonString]="selectedRow.jsonDeterminants"
                                         [determinantMapById]="determinantMapById"
                                         (onChange)="selectedRow.jsonDeterminants = $event"
                                         (onSave)="updateDeterminant($event);closeDeterminantLayer()"
                    (onCancel)="closeDeterminantLayer()" class="col-12">
                </determinant-builder-new>
            </div>
        </div>
	</div>
</div>
-->

<drawer [title]="'Manage determinants'" [showHeader]="showDrawerHeader" [isClosed]="!showDeterminantBuilder" (saveEvent)="updateDeterminant($event)" [embedded]=true (closeEvent)="closeDeterminantLayer();" class="text-left in-modal-drawer">
    <div class="drawer-content drawer-direct-content">
        <determinant-manager
            *ngIf="serviceId && selectedRow"
            [serviceId]="serviceId"
            [determinantMapById]="determinantMapById"
            [jsonString]="selectedRow.jsonDeterminants"
            (builderUpdated)="tempDeterminant = $event"
            [showBuilder]=true
            (cancel)="closeDeterminantLayer()"
            (updateHeader)="showModalHeader($event)"
            class="d-flex overflow-hidden mh-100 h-100 w-100">
        </determinant-manager>
    </div>
</drawer>